module.exports = __webpack_public_path__ + "img/slide-bar-off_03.1251012a.png";